// Generated by purs version 0.15.15
import * as $foreign from "./foreign.js";
import * as Control_Category from "../Control.Category/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Semigroup from "../Data.Semigroup/index.js";
var identity = /* #__PURE__ */ Control_Category.identity(Control_Category.categoryFn);
var extendFn = function (dictSemigroup) {
    var append = Data_Semigroup.append(dictSemigroup);
    return {
        extend: function (f) {
            return function (g) {
                return function (w) {
                    return f(function (w$prime) {
                        return g(append(w)(w$prime));
                    });
                };
            };
        },
        Functor0: function () {
            return Data_Functor.functorFn;
        }
    };
};
var extendArray = {
    extend: $foreign.arrayExtend,
    Functor0: function () {
        return Data_Functor.functorArray;
    }
};
var extend = function (dict) {
    return dict.extend;
};
var extendFlipped = function (dictExtend) {
    var extend1 = extend(dictExtend);
    return function (w) {
        return function (f) {
            return extend1(f)(w);
        };
    };
};
var duplicate = function (dictExtend) {
    return extend(dictExtend)(identity);
};
var composeCoKleisliFlipped = function (dictExtend) {
    var extend1 = extend(dictExtend);
    return function (f) {
        return function (g) {
            return function (w) {
                return f(extend1(g)(w));
            };
        };
    };
};
var composeCoKleisli = function (dictExtend) {
    var extend1 = extend(dictExtend);
    return function (f) {
        return function (g) {
            return function (w) {
                return g(extend1(f)(w));
            };
        };
    };
};
export {
    extend,
    extendFlipped,
    composeCoKleisli,
    composeCoKleisliFlipped,
    duplicate,
    extendFn,
    extendArray
};
export {
    map,
    void
} from "../Data.Functor/index.js";
